import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { api, formatApiError } from "@/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-lake-deep grain relative flex items-center justify-center px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm"
      >
        <Link to="/" className="flex items-center justify-center gap-2.5 text-glacier mb-8">
          <img src="/guidone.png" alt="Guidone Circolo Vela Manerba del Garda" className="h-14 w-auto" data-testid="admin-login-logo" />
          <span className="font-serif text-xl">Area Staff</span>
        </Link>
        <form
          data-testid="admin-login-form"
          onSubmit={submit}
          className="bg-lake-subtle border hairline-light rounded-md p-8 space-y-5"
        >
          <div>
            <label className="block font-mono text-[11px] uppercase tracking-[0.2em] text-glacier/50 mb-2">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-lake-deep border hairline-light rounded-md px-4 py-3 text-glacier outline-none focus:border-teal-light"
              placeholder="admin@circolovelamanerba.it"
            />
          </div>
          <div>
            <label className="block font-mono text-[11px] uppercase tracking-[0.2em] text-glacier/50 mb-2">Password</label>
            <input
              data-testid="admin-pin-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-lake-deep border hairline-light rounded-md px-4 py-3 text-glacier outline-none focus:border-teal-light"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-terracotta text-sm font-mono">{error}</p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-gold text-lake-deep font-semibold py-3.5 rounded-full text-sm hover:bg-glacier transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <Lock className="w-4 h-4" />
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
